import '../base';

import '../settings/animation';

// Objects & Web Components
import '../objects/light-box';
import '../objects/quantity-selector';
import '../objects/write-in-highlighter';
import '../objects/web-share-wrapper';
import '../objects/tabs';
import '../objects/sticky-atc';

// Global components (Static & NOT dynamic OS2 sections)
import '../components/navigation/header';

import '../trumps/rebuy-recharge';

// Let CSS know JS is available
document.documentElement.classList.remove('js-unavailable');
document.documentElement.classList.add('js-available');